import { useEffect, useRef, useState } from 'react';

export const useInputWidth = (
	name: string,
	editableItem: string | number | null,
	id: string | number,
	paddingRight: number | undefined,
) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const sizerRef = useRef<HTMLSpanElement>(null);
	const [inputWidth, setInputWidth] = useState(0);

	useEffect(() => {
		// Рассчитываем ширину заранее
		if (sizerRef.current && paddingRight !== undefined) {
			const newWidth = sizerRef.current.offsetWidth || 0;
			setInputWidth(newWidth + paddingRight);
		}
	}, [name, paddingRight]);

	useEffect(() => {
		// При активации редактирования обновляем ширину
		if (editableItem === id || String(editableItem) === String(id)) { // Приводим оба значения к строкам
			if (sizerRef.current && inputRef.current && paddingRight !== undefined) {
				const newWidth = sizerRef.current.offsetWidth || 0;
				setInputWidth(newWidth + paddingRight);
			}
		}
	}, [editableItem, id, paddingRight]);

	return { inputRef, sizerRef, inputWidth };
};
